import * as React from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import { CreditCard as CreditCardIcon } from '@phosphor-icons/react/dist/ssr/CreditCard';
import { ShieldCheck as ShieldCheckIcon } from '@phosphor-icons/react/dist/ssr/ShieldCheck';

import { PaymentMethodManager } from '@/components/common/payment-method-form';
import { useUser } from '@/hooks/v2/use-user';

export function UserPaymentSettings(): React.JSX.Element {
  const { community } = useUser();

  return (
    <Stack spacing={3}>
      <Card>
        <CardHeader
          avatar={
            <Avatar>
              <CreditCardIcon fontSize="var(--Icon-fontSize)" />
            </Avatar>
          }
          title="Payment Methods"
          subheader="Manage your cards and bank accounts for reservations, dues, and fees"
        />
        <CardContent>
          {community ? (
            <PaymentMethodManager communityId={community.id} community={community} />
          ) : (
            <Typography variant="body2" color="text.secondary">
              Select a community to manage payment methods.
            </Typography>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Stack direction="row" spacing={2} sx={{ alignItems: 'flex-start' }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1,
                bgcolor: 'action.hover',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <ShieldCheckIcon size={20} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                Secure payments
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Your payment information is securely stored by Stripe. We never have access to
                your full card number or bank account details. All transactions are encrypted
                and PCI compliant.
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
